import React from 'react';
import { Form, InputNumber } from 'antd';
import { Collapse } from 'react-collapse';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import i18next from 'i18next';
import moment from 'moment';
import { get } from 'lodash';

import SelectField from 'Parts/ui/components/fields/SelectField';
import DatePickerField from 'Parts/ui/components/fields/DatePickerField';
import PostalCodeField from 'Parts/ui/components/fields/PostalCodeField';
import CancelAndSaveButtons from '../../../../../dashboard/components/CancelAndSaveButtons';
import TextField from 'Parts/ui/components/fields/TextField';
import CountryField from 'Parts/ui/components/fields/CountryFieldContainer';
import Plugin from '../../../../Plugin';

import { isPluginActive } from '../../../../pluginActions';
import { getLanguageIdByKey } from 'Parts/common/langUtils';
import {
  simpleFieldValidator,
  usernameFieldValidator,
  nameFieldValidator,
  emailFieldValidator
} from 'Parts/ui/validations/fieldValidations';

import EventAdminAddOfflineTicketForm_en from './locales/EventAdminAddOfflineTicketForm_en.json';
import EventAdminAddOfflineTicketForm_fr from './locales/EventAdminAddOfflineTicketForm_fr.json';

import './EventAdminAddOfflineTicketForm.less';

class EventAdminAddOfflineTicketForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showCorpoInfo:
        props.transaction && props.transaction.donation && props.transaction.donation.typeId === 2
          ? true
          : false,
      country:
        props.transaction && props.transaction.donation && props.transaction.donation.country
          ? props.transaction.donation.country
          : null,
      administrator: null,
      campaignOwner: null,
      owner: props.userId === props.transaction.userId,
      requestUpdateModalVisible: false,
      target: null,
      available: 0,
      ticketLimit: null,
      quantity: 0,
      ticketInfoFields: null
    };

    this.campaignId = get(props, 'match.params.campaignID', null);

    this.props.fetchTicketList(this.campaignId, {showDescription: true});
    this.props.fetchEvent(this.campaignId, true, {showSettings: true})

    i18next.addResourceBundle('en', 'EventAdminAddOfflineTicketForm', EventAdminAddOfflineTicketForm_en);
    i18next.addResourceBundle('fr', 'EventAdminAddOfflineTicketForm', EventAdminAddOfflineTicketForm_fr);
  }

  componentDidMount() {
    this.setState({
      administrator: this.props.checkAuthorization({ platform: this.props.platform.id }, [
        ['roles.platform.OWNER'],
        ['roles.platform.SUPERADMIN']
      ]),
      campaignOwner: this.props.checkAuthorization({ campaign: this.props.campaign.id }, [
        'roles.campaign.OWNER'
      ])
    });
  }

  componentDidUpdate(prevProps) {
    const { props, state } = this,
      { transaction, checkAuthorization, platform, campaign } = props,
      { administrator, campaignOwner } = state;

    if (transaction !== prevProps.transaction) {
      this.setState({
        showCorpoInfo: get(transaction, 'donation.typeId', 0) === 2 ? true : false,
        country: get(transaction, 'donation.country', null)
      });
    }

    let authorization;
    if (administrator === null) {
      authorization = checkAuthorization({ platform: platform.id }, [
        ['roles.platform.OWNER'],
        ['roles.platform.SUPERADMIN']
      ]);
      if (typeof authorization === 'boolean') {
        this.setState({
          administrator: authorization
        });
      }
    }

    if (campaignOwner === null) {
      authorization = checkAuthorization({ campaign: campaign.id }, ['roles.campaign.OWNER']);
      if (typeof authorization === 'boolean') {
        this.setState({
          campaignOwner: authorization
        });
      }
    }
  }

  handleSubmit = event => {
    event.preventDefault();

    const { props } = this,
      { form, history, locale } = props,
      { validateFields } = form;

    // The force option is required because we have dynamic rules
    // See https://github.com/react-component/form/issues/130
    validateFields({ force: true }, (err, allValues) => {
      if (!err) {
        let attendees = []

        let isInfoRequested = get(this.props, 'eventSettings.attendee.information.request') == 1;
        let isEmailRequested = get(this.props, 'eventSettings.attendee.information.email') == 1;
        let isUsernameRequested  = get(this.props, 'eventSettings.attendee.information.username') == 1;

        for (let i = 1; i <= (allValues.quantity || 0); i++){
          if(isInfoRequested) {
            attendees.push({
              firstName: allValues['ticket_first_name_'+i] || undefined,
              lastName: allValues['ticket_last_name_'+i] || undefined,
              email: isEmailRequested && allValues['ticket_email_'+i] || undefined,
              username: isUsernameRequested && allValues['ticket_user_name_'+i] || undefined,
            });
          } else {
            attendees.push({
              firstName: allValues.first_name || undefined,
              lastName: allValues.last_name || undefined,
              // email: allValues.email_address || undefined,
              // username: allValues.user_name || undefined,
            });
          }
        }

        // Format phone number
        let phoneNumber = allValues.number.toString();
        if (phoneNumber.length <= 4) {
          phoneNumber = phoneNumber;
        } else
        if (phoneNumber.length <= 7) {
          phoneNumber = phoneNumber.substring(0, 3) + '-' + phoneNumber.substring(3);
        } else
        if (phoneNumber.length <= 10) {
          phoneNumber = phoneNumber.substring(0, 3) + '-' + phoneNumber.substring(3, 6) + '-' + phoneNumber.substring(6);
        } else
        if (phoneNumber.length > 10) {
          const countryLength = phoneNumber.length - 10;
          phoneNumber = phoneNumber.substring(0, countryLength) + '-' +
                        phoneNumber.substring(countryLength, countryLength + 3) + '-' +
                        phoneNumber.substring(countryLength + 3, countryLength + 6) + '-' +
                        phoneNumber.substring(countryLength + 6);
        } else {
          phoneNumber = phoneNumber;
        }
        const values = {
          donationTypeId: allValues.donation_type || undefined,
          tickets:[
            {
              ticketId: allValues.ticket_id || undefined,
              quantity: allValues.quantity || undefined,
              attendees: attendees
            }
          ],
          transaction: {
            paymentTypeId: allValues.payment_method || undefined,
            date: allValues['transaction_date'].format('YYYY-MM-DD HH:mm:ss'),
            information: {
              organizationTitle: allValues.donation_type == 2 && allValues.job_title || undefined,
              organizationName: allValues.donation_type == 2 && allValues.business_name || undefined,
              honorificId: allValues.title || undefined,
              firstName: allValues.first_name || undefined,
              lastName: allValues.last_name || undefined,
              email: allValues.email_address || undefined,
              country: allValues.country || undefined,
              province: allValues.province || undefined,
              city: allValues.city || undefined,
              address: allValues.address || undefined,
              unit: allValues.unit || undefined,
              postalCode: allValues.postalCode || undefined,
              phone: {
                number: phoneNumber || undefined,
                ext: allValues.ext || undefined
              },
              languageId: allValues.languageId || undefined
            }
          }
        };

        this.props.purchaseOfflineTicket(this.campaignId, values)
          .then(response => {
            if (response.type === 'PURCHASE_OFFLINE_TICKET_SUCCESS' && get(response, 'payload.transaction.id')) {
              history.push(`/${locale}/d/campaigns/${this.campaignId}/transactions/${get(response, 'payload.transaction.id')}`);
            }
          });
      }
    });
  };

  handleChange = value => {
    if (this.state.showCorpoInfo && value !== 2) {
      this.setState({
        showCorpoInfo: false
      });
      this.props.form.setFieldsValue({
        organizationName: '',
        organizationTitle: ''
      });
    } else if (!this.state.showCorpoInfo && value === 2) {
      this.setState({
        showCorpoInfo: true
      });
    }
  };

  onCountryChange = value => {
    this.setState({
      country: value
    });
  };

  onClickCancel = () => {
    this.props.form.resetFields();
  };

  unformatPhoneNumber = value => value
    ? value.toString().split('-').join('').split('(').join('').split(')').join('').split('+').join('').split(' ').join('').split('.').join('')
    : value;

  handleChangeTicket = value => {
    let available = value && get(this, 'props.tickets.results.length') &&
      this.props.tickets.results.filter(ticket => ticket.id == value).map(ticket => ticket.available)[0]
      || 0;
    let ticketLimit = value && get(this, 'props.tickets.results.length') &&
      this.props.tickets.results.filter(ticket => ticket.id == value).map(ticket => ticket.limitPerTransaction)[0]
      || 0;
    this.setState({
      available: parseInt(available),
      ticketLimit: ticketLimit || null,
      quantity: this.state.quantity > 0 && this.state.quantity <= ticketLimit && this.state.quantity ||
                this.state.quantity > 0 && this.state.quantity > ticketLimit && ticketLimit || 1
    }, ()=>{
      this.props.form.setFieldsValue({'quantity': this.state.quantity > 0 && this.state.quantity || 1});
      this.props.form.validateFields(['quantity']);
      this.genTicketInfoFields();
    });
  };


  genTicketInfoFields = () => {
    let { t, form } = this.props;
    let isEmailRequested = get(this.props, 'eventSettings.attendee.information.email') == 1;
    let isUsernameRequested  = get(this.props, 'eventSettings.attendee.information.username') == 1;

    let quantity = this.state.quantity;
    let fields = [];
    let fieldNames = [];

    for (let number = 1; number <= quantity; number ++) {
      let _firstname = this.props.form.getFieldValue('ticket_first_name_'+number);
      _firstname = _firstname && _firstname.trim() != "" ? _firstname.trim() : undefined;
      let _lastname = this.props.form.getFieldValue('ticket_last_name_'+number);
      _lastname = _lastname && _lastname.trim() != "" ? _lastname.trim() : undefined;
      let _username = this.props.form.getFieldValue('ticket_user_name_'+number);
      _username = _username && _username.trim() != "" ? _username.trim() : undefined;
      let _email = this.props.form.getFieldValue('ticket_email_'+number);
      _email = _email && _email.trim() != "" ? _email.trim() : undefined;

      let firstNameField = <TextField
        form={form}
        label={t('FIELDS:first-name')}
        fieldId={'ticket_first_name_'+number}
        maxlength={75}
        counter={true}
        hasFeedback
        fieldOptions={{
          rules: [...nameFieldValidator(true, 75, true, 'firstname')]
        }}
        disabled={!this.state.administrator}
        required
        initialValue={_firstname}
      />;
      _firstname && fieldNames.push('ticket_first_name_'+number);

      let lastNameField = <TextField
        form={form}
        label={t('FIELDS:last-name')}
        fieldId={'ticket_last_name_'+number}
        maxlength={75}
        counter={true}
        hasFeedback
        fieldOptions={{
          rules: [...nameFieldValidator(true, 75, true, 'lastname')]
        }}
        disabled={!this.state.administrator}
        required
        initialValue={_lastname}
      />;
      _lastname && fieldNames.push('ticket_last_name_'+number);

      let userNameField = isUsernameRequested &&
      <TextField
        form={form}
        label={t('FIELDS:user-name')}
        fieldId={'ticket_user_name_'+number}
        maxlength={75}
        counter={true}
        hasFeedback
        fieldOptions={{
          rules: [...usernameFieldValidator(true, 75, true)]
        }}
        disabled={!this.state.administrator}
        required
        initialValue={_username}
      /> || null;
      isUsernameRequested && _username && fieldNames.push('ticket_user_name_'+number);

      let emailField = isEmailRequested &&
      <TextField
        form={form}
        label={t('FIELDS:email')}
        fieldId={'ticket_email_'+number}
        hasFeedback
        fieldOptions={{
          rules: [...emailFieldValidator(true, true)]
        }}
        disabled={!this.state.administrator}
        required
        initialValue={_email}
      /> || null;
      isEmailRequested && _email && fieldNames.push('ticket_email_'+number);

      fields.push(
        <div key={"ticket_"+number} className="EventAdminAddOfflineTicketForm__ticketInfoContainer">
          <h4>{t('Ticket')} #{number}</h4>
          {emailField}
          {firstNameField}
          {lastNameField}
          {userNameField}
        </div>
      );

    }

    if (fields && !fields.length) fields = null;

    this.setState({
      ticketInfoFields: fields
    }, () => {this.props.form.validateFields(fieldNames);});
  };

  handleQuantity = value => {
    let _val = this.props.form.getFieldValue('quantity');
    if (value != _val) {
      this.props.form.setFieldsValue({'quantity': value});
      this.props.form.validateFields(['quantity'])
        .then(() => {
          this.setState({
            quantity: value
          }, this.genTicketInfoFields);
        })
        .catch(() => {
          this.setState({
            quantity: 0,
            ticketInfoFields: null
          });
        });
    }
  };

  render() {
    const { props, state } = this,
      { t, locale, form, provinces, platform } = props,
      { showCorpoInfo, ticketLimit, available, ticketInfoFields } = state;

    const paymentMethodOptions = [
      { value: 1, text: t('card') },
      { value: 3, text: t('cash') },
      { value: 2, text: t('cheque') }
    ];

    const transactionTypeOptions = [
      { value: 1, text: t('Personal') },
      { value: 2, text: t('Corporate') },
      //{ value: 3, text: t('Combined') }
    ];

    const titleOptions = [
      { value: 1, text: t('Mr') },
      { value: 2, text: t('Ms') },
      { value: 3, text: t('Miss') },
      { value: 4, text: t('Mx') }
    ];

    const languageOptions = [
      { value: 1, text: t('English') },
      { value: 2, text: t('French') }
    ];

    // Display fields even if the plugin is not active
    const TaxReceiptInformationFields =
      <Plugin
        name="TaxReceipt"
        component="AdminInformationFields"
        {...{
          // Props
          form: form,
          provinces: provinces,
          locale: locale,
          organization: showCorpoInfo
        }}
      />;

    const ticketOptions = get(this, 'props.tickets.results') && [
      ...this.props.tickets.results.map(ticket => ({
        value: ticket.id,
        text: ticket.description.name
      }))
    ] || [];

    let informationRequested = get(this.props, 'eventSettings.attendee.information.request') == 1;

    return (
      <Form className="AddTransactionsPageForm" onSubmit={this.handleSubmit}>
        <div className="inputs">
          <h3>{t('Purchase details')}</h3>
          <SelectField
            form={form}
            label={t('Ticket')}
            fieldId={'ticket_id'}
            optionsArray={ticketOptions}
            //style={{ width: 200 }}
            required={true}
            requiredMessage={t('ticket-required')}
            onChange={this.handleChangeTicket}
          />
          <Form.Item
            className='NumberField'
            label={t('quantity')}
            hasFeedback
          >
            {this.props.form.getFieldDecorator('quantity', {
              initialValue: this.state.quantity,
              rules: [
                {
                  required: true,
                  message: t('required-quantity')
                },
                {// If value is less than 1, show message.
                  validator: (rule, value, callback) => {
                    const _value = isNaN(parseFloat(value)) ? 0 : parseFloat(value);
                    return _value >= 1 ? callback() : callback(true);
                  },
                  message: t('number-minimum', { count: 1 })
                },
                {// If value is over available and available is higher than 0, show message.
                  validator: (rule, value, callback) => {
                    const _value = isNaN(parseFloat(value)) ? 0 : parseFloat(value);
                    let shorterLimit = this.state.ticketLimit && this.state.ticketLimit < this.state.available
                      ? this.state.ticketLimit
                      : this.state.available;
                    return _value <= shorterLimit ||
                          shorterLimit <= 0
                            ? callback()
                            : callback(true);
                  },
                  message: t('number-maximum', { count: this.state.ticketLimit && this.state.ticketLimit < this.state.available
                    ? this.state.ticketLimit
                    : this.state.available })
                },
                {// If available is 0 or less, show message.
                  validator: (rule, value, callback) => {
                    return this.state.available > 0 ? callback() : callback(true);
                  },
                  message: t('ticket-unavailable')
                }
              ],
              ...(informationRequested
                ? { onChange: this.handleQuantity }
                : {}
              )
            })(
              <InputNumber
                style={{ width: 200 }}
              />
            )}
            <span> / {t('remaining-tickets',{count: available})}{ticketLimit && t('per-transaction',{count: ticketLimit}) || null}</span>
          </Form.Item>
          <DatePickerField
            form={form}
            fieldId="transaction_date"
            initialValue={moment()}
            showTime={true}
            label={t('Transaction date')}
            allowClear={false}
            required={true}
            requiredMessage={t('transaction-date-required')}
            hasFeedback
            past
          />
          <SelectField
            form={form}
            label={t('Payment method')}
            fieldId={'payment_method'}
            optionsArray={paymentMethodOptions}
            style={{ width: 200 }}
            required={true}
            requiredMessage={t('payment-method-required')}
          />

          {informationRequested && this.state.quantity > 0 &&
          <>
          <h3>{t('Ticket information')}</h3>
          {ticketInfoFields}
          </> ||
          null}

          <h3>{t('Donor information')}</h3>
          <SelectField
            form={form}
            label={t('Donation type')}
            fieldId={'donation_type'}
            optionsArray={transactionTypeOptions}
            style={{ width: 200 }}
            onChange={this.handleChange}
            disabled={!this.state.administrator}
            required={true}
            requiredMessage={t('donation-type-required')}
          />
          <SelectField
            form={form}
            label={t('Title')}
            fieldId={'title'}
            optionsArray={titleOptions}
            style={{ width: 100 }}
            disabled={!this.state.administrator}
            required={true}
            requiredMessage={t('title-required')}
          />
          <TextField
            form={form}
            label={t('FIELDS:first-name')}
            fieldId={'first_name'}
            maxlength={75}
            counter={true}
            hasFeedback
            fieldOptions={{
              rules: [...nameFieldValidator(true, 75, true, 'firstname')]
            }}
            disabled={!this.state.administrator}
          />
          <TextField
            form={form}
            label={t('FIELDS:last-name')}
            fieldId={'last_name'}
            maxlength={75}
            counter={true}
            hasFeedback
            fieldOptions={{
              rules: [...nameFieldValidator(true, 75, true, 'lastname')]
            }}
            disabled={!this.state.administrator}
          />
          <TextField
            form={form}
            label={t('Email Address')}
            fieldId={'email_address'}
            hasFeedback
            fieldOptions={{
              rules: [...emailFieldValidator(true, true)]
            }}
            disabled={!this.state.administrator}
          />
          <SelectField
            form={form}
            label={t('Preferred language')}
            fieldId={'languageId'}
            optionsArray={languageOptions}
            style={{ width: 200 }}
            disabled={!this.state.administrator}
            initialValue={getLanguageIdByKey(locale)}
          />
          <Collapse isOpened={showCorpoInfo || false}>
            <TextField
              form={form}
              label={t('Business Name')}
              fieldId={'business_name'}
              hasFeedback
              fieldOptions={{
                rules: [...simpleFieldValidator(showCorpoInfo)]
              }}
              disabled={!this.state.administrator}
            />
            <TextField
              form={form}
              label={t('Job title')}
              fieldId={'job_title'}
              hasFeedback
              fieldOptions={{
                rules: [...simpleFieldValidator(showCorpoInfo)]
              }}
              disabled={!this.state.administrator}
            />
          </Collapse>
          {this.state.administrator && (
            <React.Fragment>
              <CountryField
                className="TransactionsPageForm__Field"
                form={form}
                label={true}
                placeholder={true}
                onChangeHandler={this.onCountryChange}
                required={true}
                identity={showCorpoInfo ? 'company' : 'user'}
              />
              {TaxReceiptInformationFields}
              <PostalCodeField
                className="CreateInformationForm__Field"
                form={form}
                label={true}
                placeholder={false}
                required={true}
                country={this.state.country}
                identity={showCorpoInfo ? 'company' : 'user'}
              />
            </React.Fragment>
          )}
          <Form.Item
            className='NumberField'
            label={t('phone')}
            required={true}
            hasFeedback
          >
            {this.props.form.getFieldDecorator('number', {
              rules: [
                {
                  required: true,
                  message: t('required-phone')
                },
                {
                  pattern: /^(?:1)?[0-9]{3}[0-9]{3}[0-9]{4}$/,
                  message: t('invalid-phone')
                }
              ]
            })(
              <InputNumber
                style={{ width: 200 }}
                parser={value => {
                  return this.unformatPhoneNumber(value)
                }}
                formatter={value => {
                  if (value.length <= 4) {
                    return value;
                  } else
                  if (value.length <= 7) {
                    return value.substring(0, 3) + '-' + value.substring(3);
                  } else
                  if (value.length <= 10) {
                    return value.substring(0, 3) + '-' + value.substring(3, 6) + '-' + value.substring(6);
                  } else
                  if (value.length > 10) {
                    const countryLength = value.length - 10;
                    return value.substring(0, countryLength) + '-' +
                            value.substring(countryLength, countryLength + 3) + '-' +
                            value.substring(countryLength + 3, countryLength + 6) + '-' +
                            value.substring(countryLength + 6);
                  } else {
                    return value;
                  }
                }}
              />
            )}
          </Form.Item>
          <TextField
            form={this.props.form}
            label={t('extension')}
            fieldId={'ext'}
            style={{ width: 200 }}
          />
        </div>

        <CancelAndSaveButtons
          onClickCancel={this.onClickCancel}
          isSavingInProgress={this.props.isPurchaseOfflineTicketInProgress}
        />
      </Form>
    );
  }
}

EventAdminAddOfflineTicketForm.defaultProps = {
  transaction: {
    amount: undefined,
    donation: {
      target: undefined,
      message: undefined,
      anonymous: undefined,
      typeId: undefined,
      organizationName: undefined,
      organizationTitle: undefined,
      honorificId: undefined,
      firstName: undefined,
      lastName: undefined,
      postalCode: undefined,
      country: undefined,
      email: undefined,
      languageId: undefined
    }
  }
};

EventAdminAddOfflineTicketForm.propTypes = {
  form: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired
};

export default translate('EventAdminAddOfflineTicketForm')(EventAdminAddOfflineTicketForm);
